export default [
  {
    name: 'project_contributors_statistic',
    component_path: 'modules/templates/blocks/project/ProjectStatistic',
    settings: {
      statistic: 'contributors_count',
      text: 'contributors'
    }
  }
]